<template lang="pug">
nav#header.navbar.navbar-expand-lg.fixed(
	v-bind:class='{ transparent: is_transparent, force_color: is_force_color }'
)
	.container-fluid.px-0
		router-link.navbar-brand(v-bind:to='{ name: "Index" }')
			img(src='@/assets/images/logo.png')
		button.navbar-toggler.me-md-0.me-3(
			type='button',
			data-bs-toggle='collapse',
			data-bs-target='#collapse',
			aria-controls='collapse',
			aria-expanded='false',
			aria-label='Toggle navigation'
		)
			span.navbar-toggler-icon
				font-awesome-icon(
					v-bind:icon='["fas", is_collapsed ? "bars" : "times"]'
				)
		#collapse.collapse.navbar-collapse
			ul.navbar-nav.mb-2.mb-lg-0
				li.nav-item.media
					a(href='https://www.facebook.com/TICFF.tw', target='_blank')
						font-awesome-icon(v-bind:icon='["fab", "facebook"]')
					a(href='https://www.instagram.com/ticff.tw/', target='_blank')
						font-awesome-icon(v-bind:icon='["fab", "instagram"]')
					a(
						href='https://www.youtube.com/c/%E5%8F%B0%E7%81%A3%E5%9C%8B%E9%9A%9B%E5%85%92%E7%AB%A5%E5%BD%B1%E5%B1%95TICFF',
						target='_blank'
					)
						font-awesome-icon(v-bind:icon='["fab", "youtube"]')
				li.nav-item.dropdown
					a#about.nav-link.dropdown-toggle(
						href='#',
						role='button',
						data-bs-toggle='dropdown',
						aria-expanded='false'
					)
						| {{ $t('nav_about_title') }}
					ul.dropdown-menu(aria-labelledby='about')
						li
							router-link.dropdown-item(v-bind:to='{ name: "NewsList" }') {{ $t('nav_about_news_list') }}
						li
							router-link.dropdown-item(v-bind:to='{ name: "Intro" }') {{ $t('nav_about_intro') }}
						li
							router-link.dropdown-item(v-bind:to='{ name: "Contact" }') {{ $t('nav_about_contact') }}
						li
							router-link.dropdown-item(v-bind:to='{ name: "Archive" }') {{ $t('nav_about_archive') }}
						//- li
							router-link.dropdown-item(v-bind:to='{ name: "Sponsor" }') {{ $t('nav_about_sponsor') }}
				li.nav-item.dropdown
					a#competition.nav-link.dropdown-toggle(
						href='#',
						role='button',
						data-bs-toggle='dropdown',
						aria-expanded='false'
					)
						| {{ $t('nav_competition_title') }}
					ul.dropdown-menu(aria-labelledby='competition')
						//- li
							router-link.dropdown-item(v-bind:to='{ name: "Judge" }') {{ $t('nav_competition_judge') }}
						//- li
							router-link.dropdown-item(v-bind:to='{ name: "Nominee" }') {{ $t('nav_competition_nominee') }}
						li
							router-link.dropdown-item(v-bind:to='{ name: "Rule" }') {{ $t('nav_competition_rule') }}
						li
							a.dropdown-item(
								href='https://filmfreeway.com/TICFF',
								target='_blank'
							) 
								| {{ $t('nav_competition_link') }}

				//- li.nav-item.dropdown
					a#video.nav-link.dropdown-toggle(
						href='#',
						role='button',
						data-bs-toggle='dropdown',
						aria-expanded='false'
					)
						| {{ $t('nav_video_title') }}
					ul.dropdown-menu(aria-labelledby='video')
						li
							router-link.dropdown-item(v-bind:to='{ name: "Topic" }') {{ $t('nav_video_topic') }}
						li
							router-link.dropdown-item(v-bind:to='{ name: "VideoList" }') {{ $t('nav_video_list') }}
						li
							router-link.dropdown-item(
								v-bind:to='{ name: "Video", params: { id: "special" } }'
							) {{ $t('nav_video_10th_special') }}
				//- li.nav-item.dropdown
					a#competition.nav-link.dropdown-toggle(
						href='#',
						role='button',
						data-bs-toggle='dropdown',
						aria-expanded='false'
					)
						| {{ $t('nav_faq_title') }}
					ul.dropdown-menu(aria-labelledby='competition')
						li
							router-link.dropdown-item(v-bind:to='{ name: "OTT" }') {{ $t('nav_faq_ott') }}
						li
							router-link.dropdown-item(v-bind:to='{ name: "FAQ" }') {{ $t('nav_faq_title') }}
				//- li.nav-item
					a.nav-link(href='https://www.ptsplus.tv/channel/15', target='_blank') {{ $t('nav_ptsplus') }}
				li.nav-item
					a.nav-link(
						href='https://www.pts.org.tw/dreamer9/about.html',
						target='_blank'
					) {{ $t('nav_dreamer') }}
				//- li.nav-item
				//- 	router-link.nav-link(v-bind:to='{ name: "Components" }') {{ $t('nav_components') }}
				li.nav-item(v-on:click='changeLang')
					.nav-link {{ $t('nav_language') }}
</template>

<script>
import { Collapse } from 'bootstrap';
import Cookies from 'js-cookie';
export default {
	data() {
		return {
			collapse: null,
			is_collapsed: true,
			is_transparent: true,
			is_force_color: false,
		};
	},
	methods: {
		changeLang: function () {
			if (this.$i18n.locale !== 'en') {
				this.$i18n.locale = 'en';
				Cookies.set('locale', 'en');
			} else {
				this.$i18n.locale = 'tw';
				Cookies.set('locale', 'tw');
			}
		},
	},
	created() {
		if (Cookies.get('locale')) {
			this.$i18n.locale = Cookies.get('locale');
		} else {
			Cookies.set('locale', 'tw');
		}
	},
	mounted() {
		this.collapse = new Collapse(document.getElementById('collapse'), {
			toggle: false,
		});
		document.querySelectorAll('.nav-item').forEach(item => {
			item.addEventListener('click', () => {
				this.collapse.hide();
			});
		});
		// https://dotblogs.com.tw/ShihGoGo/2017/05/18/115614
		// Viewport is less or equal to 768 pixels wide
		if (window.matchMedia('(max-width: 768px)').matches) {
			document
				.getElementById('collapse')
				.addEventListener('show.bs.collapse', () => {
					this.is_collapsed = false;
					this.is_force_color = true;
					this.is_transparent = false;
				});
			document
				.getElementById('collapse')
				.addEventListener('hide.bs.collapse', () => {
					// Force collapse scroll to top when collapse hiding
					document
						.getElementById('collapse')
						.scrollTo({ top: 0, behavior: 'smooth' });
					this.is_collapsed = true;
					if (
						window.pageYOffset >
						document.getElementById('header').offsetHeight
					) {
						this.is_force_color = false;
						setTimeout(() => {
							this.is_transparent = false;
						}, 200);
					} else {
						this.is_force_color = false;
						setTimeout(() => {
							this.is_transparent = true;
						}, 200);
					}
				});
		}
		window.addEventListener('scroll', () => {
			if (
				window.pageYOffset >
				document.getElementById('header').offsetHeight
			) {
				this.is_transparent = false;
			} else {
				this.is_transparent = true;
			}
		});
	},
};
</script>

<style lang="stylus">
#header
	background-color: $color_dark
	transition: all 800ms ease-in-out
	transition-property: background-color, color
	.navbar-brand
		padding: 0
		background-color: $color_blour
		transition: background-color 800ms ease-in-out
		img
			padding: 15px 25px
			@media screen and (max-width: $screen-sm-max)
				padding: 15px
	.navbar-toggler
		&:focus
			box-shadow: 0 0 0 0.25rem white
		@media screen and (max-width: $screen-sm-max)
			padding: 0.25rem 0
	.navbar-toggler-icon
		display: flex
		justify-content: center
		align-items: center
		color: white
	.navbar-nav
		width: 100%
		justify-content: flex-end
		.nav-item.media
			margin-right: auto
			align-self: center
			a
				color: $color_light
				margin-left: 15px
				font-size: 18px
				transition: color 0.3s


	.nav-link
		color: white
		padding-top: 16px
		padding-right: 1rem !important
		padding-bottom: 16px
		padding-left: 1rem !important
		cursor: pointer
		user-select: none
		&:hover, &:focus
			color: $color_light
	ul.dropdown-menu
		min-width: unset
		margin-top: 10px
		border-radius: 15px
		background-color: $color_dark
	.dropdown-item
		color: white
		padding: 0.5rem 2rem
		&:hover
			color: $color_light
			background-color: $color_dark
	.dropdown-toggle::after
		display: none
	&.fixed
		position: fixed
		padding: 0
		left: 0
		top: 0
		width: 100%
		z-index: 999
	&.transparent
		background-color: transparent
		.nav-link
			&:hover, &:focus
				color: $color_blour
		.navbar-brand
			background-color: transparent
		.nav-item.media
			a
				color: #fff
	&.force_color
		background-color: $color_dark !important
		transition-property: none
		.nav-link
			&:hover, &:focus
				color: $color_light !important
		.navbar-brand
			background-color: $color_blour !important
			transition-property: none
		.nav-item.media
			a
				color: $color_light !important
	@media screen and (max-width: $screen-sm-max)
		// bootstrap transiton class
		.collapsing
			height: unset
			max-height: 0 !important
			padding-bottom: 0 !important
		.navbar-collapse
			overflow-y: scroll
			max-height: 0
			padding-bottom: 0
			transition: max-height 0.3s ease-in-out
			&.show
				max-height: 100vh
				padding-bottom: 75px
		.navbar-nav
			.nav-item.media
				margin: 15px 0 0
				a
					margin: 0 10px
		.nav-link
			&.dropdown-toggle
				font-size: $fs-4
				text-align: left
				padding: 1rem
		ul.dropdown-menu
			display: flex
			flex-wrap: wrap
			margin-top: 0
			border: 0
			border-radius: 0
			padding: 1rem
			background-color: #113666
			.dropdown-item
				font-size: $fs-5
			li
				flex-basis: 50%
			.show
				display: flex
</style>
